/**
 * Click Tracker
 * Automatically tracks user clicks on interactive elements
 * Sends click data to the backend API
 */
import API from "./api.js";
import Auth from "./auth.js";
const Tracker = {
  // Elements to track clicks on
  //   TRACKED_TAGS: ["BUTTON", "A", "INPUT"],
  //   TRACKED_ROLES: ["button", "link", "tab", "menuitem"],

  isInitialized: false,
  queue: [],
  flushTimeout: null,

  /**
   * Initialize click tracking
   */
  init() {
    if (this.isInitialized || !Auth.isLoggedIn()) return;

    document.addEventListener("click", (e) => this.handleClick(e), true);
    this.isInitialized = true;

    // Flush any queued events on page unload
    window.addEventListener("beforeunload", () => this.flush());
  },

  /**
   * Handle a click event
   */
  handleClick(event) {
    if (!Auth.isLoggedIn()) {
      Auth.logout();
      return;
    }

    const target = event.target.closest("[data-name]");

    // const target = event.target;

    // Only track interactive elements
    const tag = target?.tagName;

    // if (
    //   !this.TRACKED_TAGS.includes(tag) &&
    //   !this.TRACKED_ROLES.includes(role) &&
    //   !hasId
    // ) {
    //   return;
    // }

    if (!target) return;
    if (!target && ["×", "-"].includes(target.textContent.trim())) return;

    const clickData = {
      element_id:
        target.dataset.name ||
        (target.textContent || "").trim().substring(0, 100),
      element_tag: tag,
      element_text: (target.textContent || "").trim().substring(0, 100),
      page_url: window.location.pathname + window.location.hash,
    };
    // console.log(clickData);

    this.queue.push(clickData);

    // Debounce: flush after 500ms of no clicks
    clearTimeout(this.flushTimeout);
    this.flushTimeout = setTimeout(() => this.flush(), 500);
  },

  /**
   * Send queued click events to the API
   */
  async flush() {
    if (this.queue.length === 0) return;

    const events = [...this.queue];
    this.queue = [];

    // Send each event (could batch in production)
    for (const event of events) {
      try {
        await API.post("track.php", event);
      } catch (error) {
        Auth.logout(); // Force logout on API failure (e.g., token expired)
        // Silently fail - don't interrupt user experience
        console.warn("Click tracking failed:", error);
      }
    }
  },
};

// Auto-initialize when DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//     Tracker.init();
// });
export default Tracker;
